export default __webpack_public_path__ + "6497fd60ece5438071996e346026533a.png";